<template>
  <window :window-id="windowId">
    <window-tab :title="windowTitle">
      <switch-buttons :template-id="templateId"></switch-buttons>
      <div class="form-group form-row" v-if="datasetId">
        <label :for="safeId('record1')" class="col-sm-4 col-form-label">Athlete 1</label>
        <div class="col-sm-8">
          <record-select :id="safeId('record1')" v-model="recordId1" :dataset-id="datasetId"></record-select>
        </div>
      </div>
      <div class="form-group form-row">
        <div class="col-sm-8 offset-4">
          <div class="form-check form-check-inline">
            <label class="form-check-label">
              <input class="form-check-input" type="checkbox" v-model="playing1">Playing
            </label>
          </div>
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('bibNumber1')" class="col-sm-4 col-form-label">Bib number</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('bibNumber1')" v-model.lazy="bibNumber1">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('name1')" class="col-sm-4 col-form-label">Name</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('name1')" v-model.lazy="name1">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('country1')" class="col-sm-4 col-form-label">Country</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('country1')" v-model.lazy="country1">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('subtitle1')" class="col-sm-4 col-form-label">Subtitle</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('subtitle1')" v-model.lazy="subtitle1">
        </div>
      </div>
      <div class="form-group form-row">
        <div class="col-sm-12">
          <button type="button" class="btn btn-block btn-primary" @click="switchAthletes">Switch</button>
        </div>
      </div>
      <div class="form-group form-row" v-if="datasetId">
        <label :for="safeId('record2')" class="col-sm-4 col-form-label">Athlete 2</label>
        <div class="col-sm-8">
          <record-select :id="safeId('record2')" v-model="recordId2" :dataset-id="datasetId"></record-select>
        </div>
      </div>
      <div class="form-group form-row">
        <div class="col-sm-8 offset-4">
          <div class="form-check form-check-inline">
            <label class="form-check-label">
              <input class="form-check-input" type="checkbox" v-model="playing2">Playing
            </label>
          </div>
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('bibNumber2')" class="col-sm-4 col-form-label">Bib number</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('bibNumber2')" v-model.lazy="bibNumber2">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('name2')" class="col-sm-4 col-form-label">Name</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('name2')" v-model.lazy="name2">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('country2')" class="col-sm-4 col-form-label">Country</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('country2')" v-model.lazy="country2">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('subtitle2')" class="col-sm-4 col-form-label">Subtitle</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('subtitle2')" v-model.lazy="subtitle2">
        </div>
      </div>
    </window-tab>
    <window-tab title="Data" icon="database">
      <div class="form-group form-row">
        <label :for="safeId('datasetId')" class="col-sm-4 col-form-label">Dataset</label>
        <div class="col-sm-8">
          <dataset-select :id="safeId('datasetId')" v-model="datasetId"></dataset-select>
        </div>
      </div>
      <div class="form-group form-row">
        <label class="col-sm-4 col-form-label">Fields</label>
        <div class="col-sm-8">
          <input type="text" readonly class="form-control-plaintext" :value="datasetColumns">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('patternBibNumber')" class="col-sm-4 col-form-label">Bib number</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternBibNumber')" v-model.lazy="patternBibNumber">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('patternName')" class="col-sm-4 col-form-label">Name</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternName')" v-model.lazy="patternName">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('patternCountry')" class="col-sm-4 col-form-label">Country</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternCountry')" v-model.lazy="patternCountry">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('patternSubtitle')" class="col-sm-4 col-form-label">Subtitle</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternSubtitle')" v-model.lazy="patternSubtitle">
        </div>
      </div>
    </window-tab>
    <window-tab title="Settings" icon="cog">
      <template-settings :templateId="templateId"></template-settings>
    </window-tab>
  </window>
</template>

<script>
  import { templateMixin } from '@/mixins'
  import { mapOverlayData, mapTemplateData } from '../../utils/index'

  export default {
    name: 'lower-third-athlet',
    mixins: [templateMixin],
    computed: {
      ...mapOverlayData(['playing1', 'bibNumber1', 'name1', 'country1', 'subtitle1']),
      ...mapOverlayData(['playing2', 'bibNumber2', 'name2', 'country2', 'subtitle2']),
      ...mapTemplateData(['datasetId', 'recordId1', 'recordId2']),
      ...mapTemplateData({
        /* eslint-disable no-template-curly-in-string */
        patternBibNumber: {default: '${BIB}'},
        patternName: {default: '${LAST NAME} ${FIRST NAME}'},
        patternCountry: {default: '${COUNTRY}'},
        patternSubtitle: {default: ''}
        /* eslint-enable no-template-curly-in-string */
      }),
      dataset () {
        if (!this.datasetId) return null
        return this.$store.getters.dataset(this.datasetId)
      },
      datasetColumns () {
        if (!this.dataset) return
        return this.dataset.columns || []
      }
    },
    watch: {
      recordId1: function (val) {
        if (!val) {
          this.bibNumber1 = ''
          this.name1 = ''
          this.country1 = ''
          this.subtitle1 = ''
          return
        }
        let record = this.$store.getters.dataset(this.datasetId).records
          .find(r => r.recordId === val)
        if (!record) return
        record = this.mapRecord(record)
        this.bibNumber1 = record.bibNumber
        this.name1 = record.name
        this.country1 = record.country
        this.subtitle1 = record.subtitle
      },
      recordId2: function (val) {
        if (!val) {
          this.bibNumber2 = ''
          this.name2 = ''
          this.country2 = ''
          this.subtitle2 = ''
          return
        }
        let record = this.$store.getters.dataset(this.datasetId).records
          .find(r => r.recordId === val)
        if (!record) return
        record = this.mapRecord(record)
        this.bibNumber2 = record.bibNumber
        this.name2 = record.name
        this.country2 = record.country
        this.subtitle2 = record.subtitle
      }
    },
    methods: {
      mapRecord (record) {
        const result = {}
        const recordMap = {
          bibNumber: this.patternBibNumber,
          name: this.patternName,
          country: this.patternCountry,
          subtitle: this.patternSubtitle
        }
        for (let k in recordMap) {
          if (!recordMap.hasOwnProperty(k)) continue
          result[k] = recordMap[k].replace(/\$\{([\w ]+)\}/g, function (match, p1) {
            return record[p1] || ''
          })
        }
        return result
      },
      switchAthletes () {
        const temp = this.recordId2
        this.recordId2 = this.recordId1
        this.recordId1 = temp
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/templates/uiaa-lower-third-speed.vue